import { render, staticRenderFns } from "./PersonasTabDatosPersonales.vue?vue&type=template&id=ecaade90&"
import script from "./PersonasTabDatosPersonales.vue?vue&type=script&lang=js&"
export * from "./PersonasTabDatosPersonales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports